// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1THlC","notes":"Notes_notes__UDwvj","note":"Notes_note__3CVHY","markdown":"Notes_markdown__2dP8q"};